import flow from 'lodash/fp/flow'
import get from 'lodash/fp/get'
import toNumber from 'lodash/fp/toNumber'

import { Offering } from '../../types'

export const getOfferingNumericValue = (path: string, data: Offering): number =>
  flow(get(path), toNumber)(data)
